module.exports = __webpack_public_path__ + "img/error-404.795930e1.png";